import { render } from "./SISectionTitle.vue?vue&type=template&id=c07eb350&scoped=true"
import script from "./SISectionTitle.vue?vue&type=script&lang=js"
export * from "./SISectionTitle.vue?vue&type=script&lang=js"

import "./SISectionTitle.vue?vue&type=style&index=0&id=c07eb350&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c07eb350"

export default script